import { writable } from 'svelte/store';

export const specification = writable({});
export const uiLang = writable('en');